import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapForm = React.lazy(function () {
    return import('../../bootstrap-components/components/BTForm');
});
var bootStrapForm = function (props) {
    return React.createElement(BootStrapForm, __assign({}, props));
};
var Form = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapForm(props);
            break;
        default:
            componentToDisplay = bootStrapForm(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Form.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    name: 'Form'
};
export default Form;
//# sourceMappingURL=Form.js.map